
  import * as netlifyRuntime$n9lmhjwK4TO7iXYUJl1n1DM_45XQcfmNCUFKah0h_QsBg from '/Users/sebasgona/sga/pinturas-granados/granados/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.8.2_magicast@0.5.1/node_modules/@nuxt/image/dist/runtime/providers/netlifyImageCdn'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "netlify",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['netlify']: { provider: netlifyRuntime$n9lmhjwK4TO7iXYUJl1n1DM_45XQcfmNCUFKah0h_QsBg, defaults: {} }
    }
  }
